import { useRef } from 'react';

/**
 * A ref that maintains the current value of a variable.
 * This can be used similarly to useStateRef for state managed outside of React's useState (e.g. Redux state).
 *
 * @param value current value
 * @returns ref object that contains the current value
 */
function useValueRef<T>(value: T) {
  const ref = useRef<T>(value);

  // Note that setting this during a render is not technically supported but we maintain this behavior for backwards compatibility.
  // If this ever starts breaking we can move this to a useEffect but doing so will change the timing of the update and may cause issues in consuming components.
  // See the Pitfalls section of: https://react.dev/reference/react/useRef#referencing-a-value-with-a-ref
  ref.current = value;

  return ref;
}

export default useValueRef;
